<mat-icon
  class="table-icon font-medium cursor-pointer"
  [matTooltip]="customTooltip"
  (click)="onIconClick($event)">
  {{ icon }}
</mat-icon>